import { render, staticRenderFns } from "./ActivityDisplayDayView.vue?vue&type=template&id=37cf3d31"
import script from "./ActivityDisplayDayView.vue?vue&type=script&lang=js"
export * from "./ActivityDisplayDayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports